import React from 'react'
import styles from './MicrositeAnnouncementPreview.module.css'
import { X } from 'lucide-react'

/**
 * MicrositeAnnouncementPreview
 * Mini live preview of an announcement banner strip with the
 * actual bgColor/textColor applied, so salon owners can see the
 * contrast before saving.
 *
 * Usage:
 *   <MicrositeAnnouncementPreview
 *     bannerText="Free blow-dry on bookings above ₹999!"
 *     linkText="Book now"
 *     bgColor="#0d1117"
 *     textColor="#ffffff"
 *     isDismissible
 *   />
 */
const MicrositeAnnouncementPreview = ({ bannerText, linkText, bgColor = '#0d1117', textColor = '#ffffff', isDismissible = true }) => (
    <div className={styles.wrap}>
        <div className={styles.label}>Preview</div>
        <div className={styles.banner} style={{ backgroundColor: bgColor, color: textColor }}>
            <span className={styles.text}>
                {bannerText || 'Your announcement text will appear here'}
                {linkText && <span className={styles.link}> — {linkText}</span>}
            </span>
            {isDismissible && <X size={13} className={styles.closeIcon} />}
        </div>
    </div>
)

export default MicrositeAnnouncementPreview